import { Frequency } from 'tone';
export const getRandomElement = (arr) => {
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
};
export const shuffleArray = (array) => [...array].sort(() => 0.5 - Math.random());
export const createSampleMapFromUrls = (urls, shuffle = false) => {
    const sampleMap = {};
    if (shuffle) {
        urls = shuffleArray(urls);
    }
    urls.forEach((url, index) => {
        const note = getNoteFromIndex(index);
        sampleMap[note] = url;
    });
    return sampleMap;
};
export const getNoteFromIndex = (index) => Frequency(index, "midi").toNote();
